import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import { tableData} from './data'
import './index.scss'
import CSelect from '@/components/CForm/CSelect'
import { libraryManage } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.editHandler = this.editHandler.bind(this);
    this.onChange = this.onChange.bind(this)
    this.onTableChange = this.onTableChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
    // this.getListData();
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    dataSourceall: [],
    page: tableData.tPage,
    loading: true,
    provinceid: '',
    ownerlist:[
      {id:'99',name:'全部'},
      {id:'00',name:'中央'},
      {id:'11',name:'北京'},
      {id:'12',name:'天津'},
      {id:'13',name:'河北'},
      {id:'14',name:'山西'},
      {id:'15',name:'内蒙古'},
      {id:'21',name:'辽宁'},
      {id:'22',name:'吉林'},
      {id:'23',name:'黑龙江'},
      {id:'31',name:'上海'},
      {id:'32',name:'江苏'},
      {id:'33',name:'浙江'},
      {id:'34',name:'安徽'},
      {id:'35',name:'福建'},
      {id:'36',name:'江西'},
      {id:'37',name:'山东'},
      {id:'41',name:'河南'},
      {id:'42',name:'湖北'},
      {id:'43',name:'湖南'},
      {id:'44',name:'广东'},
      {id:'45',name:'广西'},
      {id:'46',name:'海南'},
      {id:'50',name:'重庆'},
      {id:'51',name:'四川'},
      {id:'52',name:'贵州'},
      {id:'53',name:'云南'},
      {id:'54',name:'西藏'},
      {id:'61',name:'陕西'},
      {id:'62',name:'甘肃'},
      {id:'63',name:'青海'},
      {id:'64',name:'宁夏'},
      {id:'65',name:'新疆'},
      {id:'90',name:'新疆生产建设兵团'},
    ],
  };


  onTableChange(data){
    let d =this.state.dataSourceall
    var bIndex = parseInt(data.data.pageSize) * (parseInt(data.data.page) - 1);
    var eIndex = parseInt(bIndex) + parseInt(data.data.pageSize);
    var newDataList = [];
    for(var i = bIndex;i < eIndex;i++){
      if (d[i]) {
        newDataList.push(d[i]);
      }
    }
    this.setState({
      page: {...this.state.page, ...data.data},
      dataSource:newDataList
    })
  }


  // 获取用户列表数据
  getListData(){
    let getData = {
      provinceid: this.state.provinceid
    };
    this.setState({
      loading: true
    });
    libraryManage(getData).then(res=>{
      let d = JSON.parse(JSON.stringify(res.records[0].datalist))
      let  data = d.splice((this.state.page.page-1)*this.state.page.pageSize,this.state.page.page*this.state.page.pageSize)
      this.setState({
        dataSource: data,
        dataSourceall:res.records[0].datalist,
        page: {...this.state.page, total:res.records[0].datalist.length},
        loading: false,
      });
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  onChange(data){
    this.setState({
      provinceid:data
    },()=>{
      this.getListData()
    })
  }

  // 编辑当前行
  editHandler(data){
    sessionStorage.setItem('libraryuser', JSON.stringify(data))
    this.props.history.push({
      pathname: '/addlibraryUser',
      search: `?type=edit&id=${data.id}`
    })
  }
  componentWillMount(){

  }

  componentDidMount(){
    this.getListData();
  }
  render(){
    return (
        <div className='user-manage-list'>
          <div className='flex filter-wrap'>
            <div className='flex filter-left'>
              <CSelect
                  value={this.state.provinceid}
                  options={this.state.ownerlist}
                  placeholder='请选择省份'
                  onChange={this.onChange}
              />
            </div>
          </div>
          <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource}
                  page={this.state.page}
                  onTableChange={this.onTableChange}
          >
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index+1}
                    </div>
                )} />
            <div
                slot='operate1'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.editHandler(record)}>编辑</CButton>
                    </div>
                )} />
          </CTable>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
